import React from 'react';
import { Col, Row } from 'react-bootstrap';

export const PostsListContainer = ({ children }) => (
	<div className="sidebar-page-container">
		<div className="auto-container">
			<Row className="clearfix">

				<Col className="content-side" lg={8} md={8} mdOffset={2} sm={12} xs={12}>
					<section className="news-posts">
						{children}
					</section>
				</Col>

			</Row>
		</div>
	</div>
);



// WEBPACK FOOTER //
// ./src/components/ui/Blog/PostsListContainer.js